export default function() {
  return (numerator, denominator) => {
    if (typeof numerator !== 'number') numerator = 0;
    if (typeof denominator !== 'number') return 0;
    if (numerator === 0 && denominator === 0) return 100;
    const progress = (numerator / denominator) * 100;
    return progress > 100 ? 100 : progress < 0 ? 0 : progress;
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/Progress.js